export const GET_LIST_MAU_IN_NHANVAY = "GET_LIST_MAU_IN_NHANVAY";
export const GET_LIST_MAU_IN_NHANVAY_SUCCESS =
  "GET_LIST_MAU_IN_NHANVAY_SUCCESS";
export const GET_LIST_MAU_IN_NHANVAY_FAILURE =
  "GET_LIST_MAU_IN_NHANVAY_FAILURE";

export const GET_NOI_DUNG_IN_NHANVAY = "GET_NOI_DUNG_IN_NHANVAY";
export const GET_NOI_DUNG_IN_NHANVAY_SUCCESS =
  "GET_NOI_DUNG_IN_NHANVAY_SUCCESS";
export const GET_NOI_DUNG_IN_NHANVAY_FAILURE =
  "GET_NOI_DUNG_IN_NHANVAY_FAILURE";
